// extracted by css-extract-rspack-plugin
export default {"heading":"add-device-success-dialog-module__heading___S2Sdh dialog-module__heading___Mbon2"};